module.exports = __webpack_public_path__ + "img/icon92.65d6f5a6.png";